import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import TitleUpdater from "../../components/shared/title/TitleUpdater";
import Spinner from "../../components/shared/spinner/Spinner";
import styles from "./Corporate.module.scss";
import { AppDispatch, RootState } from "../../redux/store";
import { fetchTranslation } from "../../redux/Slices/translationDataSlice";
import { CorporateService } from "../../services/corporate.service";

const Corporate = () => {
  const { data } = useSelector((state: RootState) => state.translationData);
  const language = useSelector((state: RootState) => state.language.language);
  const dispatch = useDispatch<AppDispatch>();
  const initialRender = useRef(true);

  const [content, setContent] = useState<string>("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) dispatch(fetchTranslation());
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  useEffect(() => {
    setLoading(true);
    CorporateService.getCorporate()
      .then((res) => {
        setContent(res?.data?.corporate_title || "");
      })
      .catch(() => setContent(""))
      .finally(() => setLoading(false));
  }, [language]);

  return (
    <div id={styles.corporate_page}>
      <TitleUpdater
        title={
          data?.colibri && data?.corporate_title
            ? `${data.colibri} | ${data.corporate_title}`
            : "Colibri | Korporativ"
        }
      />
      <div className="container">
        <div className={styles.corporate}>
          <div className={styles.corporate_content}>
            <h1 className={styles.corporate_title}>
              {data?.corporate_title || "Korporativ"}
            </h1>
            {loading ? (
              <Spinner size="large" />
            ) : (
              <p
                className={styles.content}
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
          </div>
        </div>
      </div>
      <MobileAppSection />
    </div>
  );
};

export default Corporate;
